import { useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useErrorToast } from "@/common/hooks/useErrorToast";
import api from "@/common/utils/api";
import { translateError } from "@/common/utils/errorHandling";
import { ErrorResponse } from "@reflag/shared/api";
import {
  CodeSampleSandbox,
  CreateCodeSampleSandbox,
} from "@reflag/shared/codeSampleSandboxAPI";

export function useCodeSampleSandboxCreateMutation(featureId: string) {
  const { env, app } = useEnvironment();
  const errorToast = useErrorToast();
  const toast = useToast();

  return useMutation<
    CodeSampleSandbox,
    AxiosError<ErrorResponse>,
    CreateCodeSampleSandbox
  >({
    mutationFn: (data) =>
      api
        .post<"/apps/:appId/features/:featureId/code-sample-sandbox">(
          `/apps/${app.id}/features/${featureId}/code-sample-sandbox`,
          data,
          {
            params: {
              envId: env.id,
            },
          },
        )
        .then((response) => response.data),
    onSuccess: () => {
      toast({
        title: "Code sample sandbox created",
      });
    },
    onError: (error, variables) => {
      const { title, description } = translateError(
        error,
        `Failed to create code sample sandbox using \`${variables.template}\` template`,
      );

      errorToast({
        title,
        description,
        duration: 5000,
      });
    },
  });
}
